import { browser } from '$app/environment';

let isAndroidApp = false;

// Check if we're running in browser and if app_source=android parameter exists
export function hideLinkOnAndroid(href: string): boolean {
  if (browser) {
    const urlParams = new URLSearchParams(window.location.search);
    isAndroidApp = urlParams.get('app_source') === 'android';
  }
  return isAndroidApp && typeof href === 'string' && href.toLowerCase().includes('/join');
}
